// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__yF6lL","title":"AfterBackImages_title__1jOL4","images":"AfterBackImages_images__dbHZz"};